module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/J_10_9@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/J_10_9@2x.png
// module id = 705
// module chunks = 0